import styled from 'styled-components';

export const GridItem = styled.article`
  position: absolute;

  img {
    display: block;
  }
`;
